import React from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '../../hooks/useAuth';

/**
 * Client-side boundary for unusually privileged admin screens. The API still
 * enforces superadmin authorization; this guard prevents a normal admin from
 * mounting the page, fetching its catalog, or reaching it via a pasted URL.
 */
const SuperadminRoute = ({ children }) => {
  const { currentUser } = useAuth();

  if (currentUser?.userType !== 'admin' || currentUser?.isSuperAdmin !== true) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return children;
};

export default SuperadminRoute;
